export const LogoMark = ({ size = 36, className = "" }) => (
  <img
    src="/assets/novo-n.png"
    alt=""
    style={{ width: size, height: size }}
    className={`select-none ${className}`}
    draggable="false"
    aria-hidden="true"
  />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="novo-logo">
    <LogoMark size={compact ? 26 : 32} />
    <span className="flex flex-col leading-none text-left">
      <span className={`font-display font-bold text-neutral-50 tracking-tight ${compact ? "text-base" : "text-lg"}`}>
        Novo
      </span>
      <span className="mono text-[9px] tracking-[0.3em] text-neutral-500 mt-1">DIGITAL STUDIO</span>
    </span>
  </span>
);
